export const contactDetails = {
    email: 'estimating@topnotchmech.ca',
    phone: '+1 (289) 622-5577',
    fax: '+1 (289) 622-3999',
    address: '2 Shale Gate, North York, ON, Canada M3J 2Y8',
};
